import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoadingSummaryService {

  constructor() { }

  private loading: boolean = false;

  loadingSummary: Subject<any> = new Subject<any>();
  loadingSummaryChanged$ = this.loadingSummary.asObservable();

  setLoading(loading:boolean){
    this.loading = loading;
    this.loadingSummary.next(this.loading);
  }

  getLoading(){
    return this.loading;
  }

  clearLoading(){
    this.loading = false;
  }
}
